import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class DeductionInfoChildComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/children/:childId/b2c/deduction-info';
  }

  public static regex(step?: number): RegExp {
    return this.componentRegex(this.path(), null, step);
  }
}
